<template>
  <div>
    <div class="container">
      <div class="row">
        <div class="col">
          <div
            class="text-left"
            v-if="
              selectedGrantApplication != null || thankYouApplication != null
            "
          >
            <button class="btn btn-link" v-on:click="backToGrants">
              Back to Grants
            </button>
          </div>
          <ul
            v-if="page > 0"
            class="nav nav-pills mb-4"
            role="tablist"
            id="v-pills-tab"
          >
            <li class="nav-item mr-2">
              <button
                class="btn btn-outline-primary nav-link"
                v-bind:class="{ active: page == 1 }"
                v-on:click="changePage(1)"
              >
                Grants
              </button>
            </li>
            <li class="nav-item mr-2">
              <button
                class="btn btn-outline-primary nav-link"
                v-bind:class="{ active: page == 4 }"
                v-on:click="changePage(4)"
              >
                Download Applications
              </button>
            </li>
            <li class="nav-item">
              <button
                class="btn btn-outline-primary nav-link mr-2"
                v-bind:class="{ active: page == 2 }"
                v-on:click="changePage(2)"
              >
                Calendar
              </button>
            </li>
            <li class="nav-item">
              <button
                class="btn btn-outline-primary nav-link mr-2"
                v-bind:class="{ active: page == 3 }"
                v-on:click="changePage(3)"
              >
                My Grant Stats
              </button>
            </li>
          </ul>
          <MyGrantsList
            v-show="page == 1"
            @selectedApplication="applicationSelected"
            @thankYous="thankYous"
          />
          <Calendar v-show="page == 2" />
          <MyGrantsStats v-show="page == 3" />
          <ApplicationManagement
            v-if="selectedGrantApplication != null"
            v-bind:GrantApplication="selectedGrantApplication"
            @backToGrants="backToGrants"
          />
          <ApplicationThankYouLetters
            v-if="thankYouApplication != null"
            v-bind:GrantApplication="thankYouApplication"
            @backToGrants="backToGrants"
          />
          <ApplicationDownload v-show="page == 4" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MyGrantsList from "@/components/MyGrants/MyGrantsList";
import MyGrantsStats from "@/components/MyGrants/MyGrantsStats";
import Calendar from "@/components/MyGrants/Calendar";
import ApplicationManagement from "@/components/MyGrants/ApplicationManagement";
import ApplicationThankYouLetters from "@/components/MyGrants/ApplicationThankYouLetters";
import ApplicationDownload from "@/components/MyGrants/ApplicationDownload";
//import $ from "jquery";

export default {
  name: "MyGrants",
  components: {
    MyGrantsList,
    Calendar,
    ApplicationManagement,
    ApplicationThankYouLetters,
    MyGrantsStats,
    ApplicationDownload
  },
  data() {
    return {
      page: 1,
      selectedGrantApplication: null,
      thankYouApplication: null
    };
  },
  methods: {
    changePage(num) {
      this.page = num;
    },
    applicationSelected(application) {
      this.selectedGrantApplication = application;
      this.page = -1;
    },
    backToGrants() {
      this.selectedGrantApplication = null;
      this.thankYouApplication = null;
      this.changePage(1);
    },
    thankYous(application) {
      this.thankYouApplication = application;
      this.page = -1;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
